<template>
    <div id="app">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
</template>

<script>
import autofit from 'autofit.js';
export default {
    name: 'App',
    data() {
      return {
        transitionName: ''
      }
    },
    mounted() {
      autofit.init({
        designHeight: 1080,
        designWidth: 1920,
        renderDom:"#app",
        resize: true
      })
      this.$aegis.reportEvent({
        name: 'loaded',
        ext1: 'loaded-success',
        ext2: 'webrtcQuickDemoVue2',
      });
    }
}
</script>

<style lang="scss">
	body{
		margin: 0;
    /* background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(82,0,5,0.96) 100%); */
	}
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #16203D;
  }
  body {
    margin: 0;
    padding: 0;
    user-select: none;
  }
  @font-face{
    font-family: 'YouSheBiaoTiHei';
    src : url('@/assets/font/fontStyle.ttf');
  }
  /* @font-face{
    font-family: 'YouSheBiaoTiHei';
    src : url('@/assets/font/YouSheBiaoTiHeiBiaoTiTi-1.ttf');
  } */
  /* 隐藏谷歌 火狐，IE浏览器的滚动条 */
  *::-webkit-scrollbar {
    display: none;
  }
  /* * {
    scrollbar-width: none;
  }
  * {
    -ms-overflow-style: none;
  } */
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0.3;
}
.fade-leave, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0.3;
}

.pagination {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translate(-50%, 0);

    ::v-deep(.el-pager li:not(.disabled).active) {
      width: 33.33px;
      height: 33.33px;
      line-height: 33.33px;
      border-radius: 40px;
      opacity: 1;
      /*       border: 0.42px solid #fdcf30ff;
      background: #ffb41f0a;
      box-shadow: inset 0 0 13.33px 0 #ffb41fff; */


      border-radius: 40rpx;
      border: 1.25rpx solid #3076FF !important;
      background: linear-gradient(180deg, #9fc5ff33 23.21%, #0664f1e3 100%), radial-gradient(47.98% 50% at 50% 50%, #309cff00 0%, #309cff57 100%), linear-gradient(180deg, #77caff3d -12.58%, #77caff3d 45.05%, #77caff3d 100%), linear-gradient(180deg, #0000002e -6.62%, #00000000 53.62%, #0000002e 100%) !important;
      box-shadow: 0 0 7.5rpx 0 #1cc5e7ab inset !important;


    }

    ::v-deep(.el-pager li) {
      width: 33.33px;
      height: 33.33px;
      line-height: 33.33px;
      background: transparent;
      color: #3076FF;
      background-color: red;
    }

    ::v-deep(.el-pager li:hover) {
      color: #3076FF !important;
    }
  }


</style>
